import {Injectable} from '@angular/core';
import {
  HorizontalFullPositionType,
  VerticalPositionType
} from '@models/general';
import {DSNotificationToast} from '@ds/ds-snam';

type ToastStatusType = 'confirm' | 'error' | 'warning' | 'info';
type LegacyPanelClass = 'green-snackbar' | 'red-snackbar';
type ToastSize = 'small' | 'medium' | 'large';

@Injectable({
  providedIn: 'root'
})
export class NotificationToastService {
  horizontalPosition: HorizontalFullPositionType = 'right';
  verticalPosition: VerticalPositionType = 'top';
  duration = 7000;

  openFromPanelClass(title: string, panelClass: LegacyPanelClass, duration: number = this.duration): void {
    this.open(title, this.mapPanelClassToStatus(panelClass), duration);
  }

  open(title: string, status: ToastStatusType, duration: number = this.duration): void {
    const toast = document.createElement('ds-notification-toast') as DSNotificationToast;
    toast.notificationVariant = 'default';
    toast.notificationStatus = status;
    toast.toastTitle = title;
    toast.horizontalPosition = this.horizontalPosition;
    toast.verticalPosition = this.verticalPosition;
    toast.top = '60px';
    toast.right = '20px';
    toast.toastSize = this.computeToastSize(title);
    toast.isFixed = true;
    toast.contentFit = true;
    toast.isVisible = true;
    toast.isCloseButtonVisible = true;
    const removeToast = () => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    };
    const close = () => {
      toast.isVisible = false;
      window.setTimeout(removeToast, 0);
    };
    toast.addEventListener('onCloseToast', close);
    document.body.appendChild(toast);
    if (duration > 0) {
      window.setTimeout(close, duration);
    }
  }

  private mapPanelClassToStatus(panelClass: LegacyPanelClass): ToastStatusType {
    switch (panelClass) {
      case 'green-snackbar':
        return 'confirm';
      case 'red-snackbar':
        return 'warning';
    }
  }

  private computeToastSize(message: string): ToastSize {
    const length = (message ?? '').trim().length;
    if (length <= 30) { return 'small'; }
    return 'medium';
  }
}
